// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FileTypeSchema = z.enum(['SWAGGER','DOCS','SCOPING','TESTING_REPORTS','PROTO'] as const);

export type FileTypeType = `${z.infer<typeof FileTypeSchema>}`

export default FileTypeSchema;
